<template>
  <PageHeader>
    <template #header-title>
      {{ $t('Contracts') }}
    </template>
  </PageHeader>

  <div class="tw-max-h-full">
    <GraphqlDataTable
      :query
      :order-by="initialOrder"
      :filter-black-list="['accounts']"
      :quick-filters="['activeStatus']"
      :search-placeholder="$t('Search job, company...')"
      :max-height-adjustment="30"
      data-test="freelancer-contracts-table"
    >
      <template #action="{ row }">
        <WorkerHireActionColumn :row="row" />
      </template>
      <template #no-results>
        {{
          $t("You haven't been offered any contracts yet. Once you are, they'll be listed here.")
        }}
      </template>
    </GraphqlDataTable>
  </div>
</template>

<script lang="ts" setup>
import { TypedQueryDocumentNode } from 'graphql/index'
import GraphqlDataTable from '@/components/GraphqlDataTable/GraphqlDataTable.vue'
import PageHeader from '@/components/PageHeader.vue'
import { graphql } from '@/gql'
import { HireOrderByColumn, SortOrder } from '@/gql/graphql'
import { $t } from '@/composables/translation'
import WorkerHireActionColumn from '@/components/GraphqlDataTable/columns/Hire/WorkerHireActionColumn.vue'

const query = graphql(`
  query FreelancerContractsQuery(
    $search: String
    $page: Int!
    $first: Int!
    $orderBy: [HiresOrderByClauseInput!]
    $activeStatus: [HireActiveStatus!]
    $startDateRange: DateRangeInput
    $endDateRange: DateRangeInput
  ) {
    hires(
      search: $search
      page: $page
      first: $first
      orderBy: $orderBy
      startDateRange: $startDateRange
      endDateRange: $endDateRange
      activeStatus: $activeStatus
    ) {
      data {
        ...HireActiveStatusColumn

        ...HireCompanyColumn

        ...HireTitleNavigationColumn

        startDate
        endDate

        ...HireEngagementColumn
        ...RateColumnHire

        ...HirePaymentRequestColumn

        ...WorkerHireActionColumn
      }
    }
  }
`) as TypedQueryDocumentNode

const initialOrder = {
  field: HireOrderByColumn.CreatedAt,
  order: SortOrder.Desc,
}
</script>
